/** @format */

import { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { get_banners } from "../store/reducers/homeReducer";

const Banner = () => {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.home);
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    dispatch(get_banners());
  }, [dispatch]);

  return (
    <div className='w-full mt-6'>
      <div className='w-[99%] lg:w-[95%] mx-auto'>
        <div className='w-full flex flex-wrap md-lg:gap-8'>
          <div className='w-full'>
            <Carousel
              swipeable={false}
              draggable={false}
              showDots={true}
              responsive={responsive}
              ssr={true}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2700}
              arrows={true}
              keyBoardControl={true}
              //customTransition="all .5"
              transitionDuration={500}
              //containerClass="carousel-container"
              //removeArrowOnDeviceType={["tablet", "mobile"]}
              //deviceType={this.props.deviceType}
            >
              {banners.length > 0 &&
                banners.map((banner, index) => (
                  <Link
                    className='flex ld-md:h-[300px] w-[98%] h-auto'
                    to={`/product/details/${banner.productId}`}
                    key={index}
                  >
                    <img src={banner.link} alt='' />
                  </Link>
                ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
